import type { CanActivateFn } from '@angular/router';
import { environment } from 'src/environments/environment';

import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LOG_IN_ROUTE } from 'src/app/shared/common/constants';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const { developmentMode, isStandalonePortal, localDomain } = environment;

  const isLoggedIn = authService.checkIfLoggedIn();

  if (isLoggedIn) {
    return true;
  }

  if (isStandalonePortal) router.navigate([LOG_IN_ROUTE]);
  else if (!developmentMode && !isStandalonePortal) {
    const url = localDomain + LOG_IN_ROUTE;
    window.open(url, '_self');
  }
  return false;
};
